<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                v-if="this.filter.store_id != ''"
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.push('/orders')"
              >
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>

              <h2
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Orders' : 'Deleted Orders'"
              ></h2>

              <!-- <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/orders/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template> -->
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    hide-details
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3" v-if="this.filter.store_id != ''">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    hide-details
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <!-- <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="state"
                    v-model="filter.state"
                    :items="stateItems"
                    label="States"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col> -->
                <v-col sm="3" v-if="this.filter.store_id != ''">
                  <v-autocomplete
                    solo
                    rounded
                    ref="product"
                    v-model="filter.product_id"
                    :items="productItems"
                    hide-details
                    label="Product"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <!-- Month Year -->
                <v-col sm="3" v-if="this.filter.store_id != ''">
                  <v-menu
                    v-model="month_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.month_year"
                        label="Year - Month"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="
                          () => {
                            filter.month_year = null;
                            getData();
                          }
                        "
                        hide-details
                        :error-messages="errors.month"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.month_year"
                      type="month"
                      @input="
                        getData();
                        month_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Month Year -->
                <!-- Start date -->
                <v-col sm="3" v-if="this.filter.store_id != ''">
                  <v-menu
                    v-model="start_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.start_date"
                        label="Start Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="
                          () => {
                            filter.start_date = null;
                            getData();
                          }
                        "
                        hide-details
                        :error-messages="errors.start_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.start_date"
                      @input="
                        getData();
                        start_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Start date -->
                <!-- End date -->
                <v-col sm="3" v-if="this.filter.store_id != ''">
                  <v-menu
                    v-model="end_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.end_date"
                        label="End Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="
                          () => {
                            filter.end_date = null;
                            getData();
                          }
                        "
                        hide-details
                        :error-messages="errors.end_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.end_date"
                      @input="
                        getData();
                        end_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /End date -->
                <!-- Store -->
                <v-col>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        rounded
                        depressed
                        color="error"
                        class="my-auto"
                        @click="deleteAll(orders.id)"
                        style="width: 90px; height: 50px"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Delete all Store</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <!-- <v-card-title v-if="orders.length != 0">
              <h3 class="font-weight-bold">
                Total Product : {{ products ?? "" }}
              </h3>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                large
                class="primary mr-4"
                @click="is_excel_dialog = true"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate GST Excel</span>
              </v-btn>
              <v-btn
                rounded
                large
                class="primary"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title> -->

            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="900"
                class="striped-table"
              >
                <template v-slot:default v-if="this.filter.store_id != ''">
                  <thead>
                    <tr>
                      <th style="min-width: 100px">
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <!-- <th class="text-left">Status</th> -->
                      <th class="text-left">Order Status</th>
                      <th class="text-left">Store Name</th>
                      <th class="text-left" style="min-width: none">Date</th>
                      <th class="text-left" style="min-width: none">
                        Invoice No
                      </th>
                      <th class="text-left" style="min-width: none">
                        Welcome Bonus
                      </th>
                      <th class="text-left" style="min-width: none">
                        Transporter Wallet
                      </th>
                      <th class="text-left" style="min-width: none">
                        Driver Wallet
                      </th>
                      <th class="text-left" style="min-width: none">Point</th>
                      <th class="text-left" style="min-width: none">Cash</th>
                      <th class="text-left" style="min-width: none">Online</th>
                      <th class="text-left" style="min-width: none">
                        Total Amount
                      </th>
                      <th class="text-right action_th" style="min-width: 200px">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="orders.length != 0">
                    <tr
                      v-for="(order, i) in orders"
                      :key="`order_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': orders.length - 1 == i,
                      }"
                    >
                      <td>
                        <input type="checkbox" v-model="order.is_selected" />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <!-- <td>
                        <v-tooltip bottom v-if="order.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Order is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="order.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Order is InActive</span>
                        </v-tooltip>
                      </td> -->
                      <td>
                        <!-- Pending Order -->
                        <v-tooltip bottom v-if="order.status == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="orange"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Order is Pending</span>
                        </v-tooltip>
                        <!-- Dispatch Order -->
                        <v-tooltip bottom v-if="order.status == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="indigo"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Dispatched
                            </v-chip>
                          </template>
                          <span>Order is Dispatched</span>
                        </v-tooltip>
                        <!-- Delivered Order -->
                        <v-tooltip bottom v-if="order.status == 2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Delivered
                            </v-chip>
                          </template>
                          <span>Order is Delivered</span>
                        </v-tooltip>
                        <!-- Reject Order -->
                        <v-tooltip bottom v-if="order.status == 3">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>Order is Rejected</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ order.store ? order.store.business_name : "" }}
                      </td>
                      <td>
                        {{ order.date || "" }}
                      </td>
                      <td>
                        {{ order.invoice_no || "" }}
                      </td>
                      <td>
                        {{ order.welcome_bonus_wallet || "" }}
                      </td>
                      <td>
                        {{ order.transporter_wallet || "" }}
                      </td>
                      <td>
                        {{ order.driver_wallet || "" }}
                      </td>
                      <td>
                        {{ order.point_wallet || "" }}
                      </td>
                      <td>
                        {{ order.cash_wallet || "" }}
                      </td>
                      <td>
                        {{ order.online_wallet || "" }}
                      </td>
                      <td>
                        {{ order.total_amount || "" }}
                      </td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                class="my-auto"
                                color="success"
                                x-large
                                :disabled="order.status != 0"
                                @click="handleStatus(order, 1)"
                              >
                                <v-icon dark> mdi-check-circle-outline </v-icon>
                              </v-btn>
                            </template>
                            <span>Dispatch this Order</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                class="mx-1"
                                color="red"
                                x-large
                                :disabled="
                                  order.status == 2 || order.status == 3
                                "
                                @click="handleStatus(order, 3)"
                              >
                                <v-icon dark> mdi-close-circle-outline </v-icon>
                              </v-btn>
                            </template>
                            <span>Reject this Order</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-2 mb-2"
                                fab
                                x-small
                                color="primary"
                                :to="
                                  filter.product_id
                                    ? `/orders/${encryptIt(
                                        order.id
                                      )}/order-details?product_id=${encryptIt(
                                        filter.product_id
                                      )}`
                                    : `/orders/${encryptIt(
                                        order.id
                                      )}/order-details`
                                "
                              >
                                <v-icon dark>mdi-content-duplicate</v-icon>
                              </v-btn>
                            </template>
                            <span>View Order Details</span>
                          </v-tooltip>
                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="ml-2"
                                color="primary"
                                :to="`/orders/${encryptIt(order.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Order</span>
                          </v-tooltip> -->
                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(order.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Order</span>
                          </v-tooltip> -->
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(order.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this order</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
                <template v-slot:default v-else>
                  <thead>
                    <tr>
                      <th style="min-width: 90px">
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <th class="text-start">Status</th>
                      <th class="text-start" style="min-width: 220px">
                        Store Name
                      </th>
                      <th class="text-start">Store State</th>
                      <th class="text-start">Store Location</th>
                      <th class="text-start">Store Code</th>
                      <th class="text-start">Total Pendings</th>
                      <th class="text-start">Total Dispatched</th>
                      <th class="text-start">Total Delivered</th>
                      <th class="text-start">Total Rejected</th>
                      <th class="text-right action_th" style="min-width: 50px">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="orders.length != 0">
                    <tr
                      v-for="(order, i) in orders"
                      :key="`order_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': orders.length - 1 == i,
                      }"
                    >
                      <td>
                        <input type="checkbox" v-model="order.is_selected" />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="order.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Order is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="order.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Order is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ order.store ? order.store.business_name : "" }}
                      </td>
                      <td>
                        {{ order.store ? order.store.state_jurisdiction : "" }}
                      </td>
                      <td>
                        {{ order.store ? order.store.store_location : "" }}
                      </td>
                      <td>
                        {{ order.store ? order.store.store_code : "" }}
                      </td>
                      <td>
                        {{
                          order.total_pending_orders
                            ? order.total_pending_orders
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          order.total_dispatch_orders
                            ? order.total_dispatch_orders
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          order.total_delivered_orders
                            ? order.total_delivered_orders
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          order.total_rejected_orders
                            ? order.total_rejected_orders
                            : ""
                        }}
                      </td>

                      <!-- <td>
                        {{ order.date || "" }}
                      </td> -->
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-2 mb-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/orders?store_id=${encryptIt(
                                  order.store_id
                                )}`"
                              >
                                <v-icon dark>mdi mdi-eye</v-icon>
                              </v-btn>
                            </template>
                            <span>View Order List</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="is_excel_dialog" width="600">
        <v-card>
          <v-card-title>Generate Orders with GST Excel</v-card-title>
          <v-divider class="mb-5"></v-divider>
          <v-card-text>
            <v-row>
              <v-col sm="12">
                <v-autocomplete
                  ref="user"
                  outlined
                  v-model="filter.gst_no"
                  :items="gstItems"
                  label="GST Number"
                  prepend-inner-icon="mdi-account"
                  clearable
                  :error-messages="errors.gst_no"
                ></v-autocomplete>
              </v-col>

              <!-- Start date -->
              <v-col sm="6">
                <v-menu
                  v-model="start_date_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      v-model="filter.start_month_year"
                      label="Year - Month"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      @click:clear="filter.start_month_year = null"
                      :error-messages="errors.start_month_year"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filter.start_month_year"
                    type="month"
                    @change="start_date_menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <!-- /Start date -->
              <!-- End date -->
              <v-col sm="6">
                <v-menu
                  v-model="end_date_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      v-model="filter.end_month_year"
                      label="Year - Month"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      @click:clear="filter.end_month_year = null"
                      :error-messages="errors.end_month_year"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filter.end_month_year"
                    type="month"
                    @change="end_date_menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <!-- /End date -->
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" @click="is_excel_dialog = false">
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="generateGstExcel"
              :loading="isGstExcelLoading"
            >
              Download
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_order" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Orders deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_order = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_store" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Order restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_store = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Confirmation Dialog Component -->
      <ConfirmationDialog
        :show.sync="dialog"
        :title="dialogTitle"
        :message="dialogMessage"
        :icon="dialogIcon"
        :color="dialogColor"
        :isRejection="isRejection"
        @confirm="confirmApproval"
      />
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
export default {
  components: { ConfirmationDialog },
  name: "OrdersPage",
  data() {
    return {
      filter: {
        product_id: "",
        position_id: "",
        user_id: "",
        store_id: "",
        vehicle_maker: "",
        state: "",
        search_keyword: "",
        is_active: "",
        is_selected: false,
        month_year: "",
        start_date: "",
        end_date: "",
        start_month_year: "",
        end_month_year: "",
        gst_no: "",
      },
      products: 0,
      productItems: [],
      vehicle_makersItems: [],
      stateItems: [],
      usersItems: [],
      positionItems: [],
      storeItems: [],
      orders: [],
      stores: [],
      gstItems: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportOrderTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      is_restored_store: false,
      isExcelloading: false,
      isGstExcelLoading: false,
      delete_order: false,
      is_deleted_order: false,
      is_select_all: false,
      isDeleteAll: false,
      month_menu: false,
      start_menu: false,
      end_menu: false,
      start_date_menu: false,
      end_date_menu: false,
      is_excel_dialog: false,

      selectedOrderId: null,
      selectedOrderStatus: null,
      isRejection: false,
      dialog: false,
      dialogTitle: "",
      dialogMessage: "",
      dialogIcon: "",
      dialogColor: "",
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
      this.getMasters();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`orders/masters`)
        .then((masters) => {
          masters = masters.data;
          //Product
          masters.products.forEach((product) => {
            this.productItems.push({
              id: product.id,
              text: product.name,
              value: product.id,
            });
          });
          //State
          masters.states.forEach((state) => {
            this.stateItems.push({
              id: state.id,
              text: state.name,
              value: state.name,
            });
          });
          //Store
          masters.stores.forEach((store) => {
            this.storeItems.push({
              id: store.id,
              text: store.name,
              value: store.id,
            });
            this.gstItems.push({
              id: store.id,
              text: store.gst_no,
              value: store.gst_no,
            });
          });
          //Position
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
          //User
          masters.users.forEach((user) => {
            this.usersItems.push({
              id: user.id,
              text: user.first_name,
              value: user.id,
            });
          });
          //User
          masters.vehicle_makers.forEach((vehicle_maker) => {
            this.vehicle_makersItems.push({
              id: vehicle_maker.id,
              text: vehicle_maker.name,
              value: vehicle_maker.name,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state = this.filter.state ? this.filter.state : "";
      this.filter.vehicle_maker = this.filter.vehicle_maker
        ? this.filter.vehicle_maker
        : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      if (this.$route.query.store_id != null) {
        this.filter.store_id = this.decryptIt(this.$route.query.store_id);
      } else {
        this.filter.store_id = "";
      }
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&role_id=2" +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&store_id=" +
        this.filter.store_id +
        "&position_id=" +
        this.filter.position_id +
        "&state=" +
        this.filter.state +
        "&vehicle_maker=" +
        this.filter.vehicle_maker +
        "&city=" +
        this.filter.city +
        "&month_year=" +
        this.filter.month_year +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`orders?${query}`)
        .then((response) => {
          this.orders = response.data.data;
          this.products = response.data.data1;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },

    async Delete_this(id) {
      this.delete_order = true;
      await axios
        .post(`/orders/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_order = false;
          this.is_deleted_order = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
    selectAll() {
      console.log(this.is_select_all);
      this.orders.forEach((order) => {
        order.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      let deleteallIds = [];
      this.orders.forEach((order) => {
        if (order.is_selected) deleteallIds.push(order);
      });
      await axios
        .post("/orders/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      // let response = await axios.post(/sync_users/upstart_datert_date, this.form);
      this.isDeleteAll = false;
    },
    //Generate Excel
    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state = this.filter.state ? this.filter.state : "";
      this.filter.vehicle_maker = this.filter.vehicle_maker
        ? this.filter.vehicle_maker
        : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      if (this.$route.query.store_id != null) {
        this.filter.store_id = this.decryptIt(this.$route.query.store_id);
      } else {
        this.filter.store_id = "";
      }
      let response = [];
      let query =
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&store_id=" +
        this.filter.store_id +
        "&position_id=" +
        this.filter.position_id +
        "&state=" +
        this.filter.state +
        "&vehicle_maker=" +
        this.filter.vehicle_maker +
        "&city=" +
        this.filter.city +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&month_year=" +
        this.filter.month_year +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/orders/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
    async generateGstExcel() {
      this.isGstExcelLoading = true;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.start_month_year = this.filter.start_month_year
        ? this.filter.start_month_year
        : "";
      this.filter.end_month_year = this.filter.end_month_year
        ? this.filter.end_month_year
        : "";
      let query =
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&gst_no=" +
        this.filter.gst_no +
        "&start_month_year=" +
        this.filter.start_month_year +
        "&end_month_year=" +
        this.filter.end_month_year;
      await axios.get(`/orders/gst_excel_export?${query}`).then((response) => {
        this.isGstExcelLoading = false;
        this.filter.start_month_year = "";
        this.filter.end_month_year = "";
        this.filter.gst_no = "";
        window.open(`${response.data.data}`, "_blank");
      });
      this.isGstExcelLoading = false;
      this.is_excel_dialog = false;
    },
    async Restore_this(id) {
      this.restore_order = true;
      await axios
        .post(`/orders/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_order = false;
          this.is_restored_order = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
    handleStatus(order, status) {
      const isApproval = status === 1;
      this.dialogTitle = isApproval ? "Dispatch Order" : "Reject Order";

      this.dialogMessage = isApproval
        ? "Are you sure you want to dispatch this Order?"
        : "Are you sure you want to reject this Order?";

      this.dialogIcon = isApproval
        ? "mdi-check-circle-outline"
        : "mdi-alert-circle-outline";

      this.dialogColor = isApproval ? "green" : "red";

      this.selectedOrderId = order.id;
      this.selectedOrderStatus = status;
      this.isRejection = !isApproval;
      this.dialog = true; // Open dialog
    },
    async confirmApproval(rejectionReason) {
      const payload = {
        status: this.selectedOrderStatus,
        remark: this.selectedOrderStatus === 3 ? rejectionReason : null,
      };
      await axios
        .patch(`/orders/${this.selectedOrderId}`, payload)
        .then(() => {
          this.getData();
          if (this.selectedOrderStatus == 1) {
            this.$toast.success("Organisation is approved successfully!", {
              position: "top-right",
              timeout: 3000,
            });
          } else {
            this.$toast.error("Organisation is rejected!", {
              position: "top-right",
              timeout: 3000,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });

      this.selectedOrderId = "";
      this.selectedOrderStatus = "";
    },
  },
};
</script>
